import gsap from 'gsap'

export function initTextMask(): void {
  // Animate the transition text
  const transitionText = document.querySelector('.quote__transition-text')
  if (transitionText) {
    gsap.fromTo(
      transitionText,
      {
        opacity: 0,
        y: 30,
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: '.quote__transition',
          start: 'top 80%',
          toggleActions: 'play none none reverse',
        },
      }
    )
  }

  // Animate columns
  const quoteText = document.querySelector('.quote__text')
  const quoteMedia = document.querySelector('.quote__media-placeholder')

  if (quoteText && quoteMedia) {
    gsap.fromTo(
      quoteText,
      {
        opacity: 0,
        x: -50,
      },
      {
        opacity: 1,
        x: 0,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: '.quote__columns',
          start: 'top 70%',
          toggleActions: 'play none none reverse',
        },
      }
    )

    gsap.fromTo(
      quoteMedia,
      {
        opacity: 0,
        x: 50,
      },
      {
        opacity: 1,
        x: 0,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: '.quote__columns',
          start: 'top 70%',
          toggleActions: 'play none none reverse',
        },
      }
    )
  }
}
